// src/services/ChargementEtudiantsService.js
import axios from "axios";
import { AdresseIP } from '../AdresseIP';

export class ChergementEtudiantsService {
  constructor() {
    this.adresse = new AdresseIP()
    this.backendUrl ='/service/api/diplome/authentification/inscription-upload'
    this.API_URL = this.adresse.getAdresseIP()+this.backendUrl
  }
  chargerEtudiants(payload) {
    return axios.post(this.API_URL,payload)
                    .then(res => res.data);
  }
  /*chargerEtudiants = async (payload) => {
    try {
      const response = await axios.post(this.API_URL, {
          payload: payload,
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors du chargement des étudiants :", error);
      throw error;
    }
  };*/

}


